// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullRegattaResultTableRace,
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Enums
import {
  RegattaResultTableRaceType,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Label,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputCheckbox,
  InputDoubleButton,
  InputNumber,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import {
  regattaResultTableRaceTypeLabel,
} from 'common.language';

// Types
type $Props = $Translate & {
  item: $FullRegattaResultTableRace | $Model<'RegattaResultTableRace'> | $ModelUpsertParams<'RegattaResultTableRace'>;
};

const RegattaResultTableRaceFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col xs={4}>
          <InputDoubleButton
            label={t('Visibility')}
            labelFalse={t('Hidden')}
            labelTrue={t('Visible')}
            name={'Public'}
            value={item.Public}
          />
        </Col>
        <Col xs={8}>
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <AvField
            label={t('Type')}
            name={'Type'}
            required
            type={'select'}
            value={item.Type}
          >
            {_.map(
              RegattaResultTableRaceType,
              (i) => (
                <option
                  key={i}
                  value={i}
                >
                  {t(regattaResultTableRaceTypeLabel[i])}
                </option>
              ),
            )}
          </AvField>
        </Col>
        <Col
          sm={3}
          xs={6}
        >
          <InputNumber
            label={`${t('Distance')} (NM)`}
            name={'Distance'}
            value={item.Distance}
          />
        </Col>
        <Col
          sm={3}
          xs={6}
        >
          <InputNumber
            label={t('Coef')}
            min={0}
            name={'Coef'}
            required
            value={item.Coef}
          />
        </Col>
      </Row>
      <Label className={'mb-3'}>
        {t('Start time')}
      </Label>
      <Row>
        <Col className={'mb-3'}>
          <Row className={'no-gutters'}>
            <Col>
              <InputNumber
                label={t('Year')}
                min={0}
                name={'Year'}
                required
                value={item.Year}
              />
            </Col>
            <Col>
              <InputNumber
                label={t('Month')}
                max={12}
                min={0}
                name={'Month'}
                required
                value={item.Month}
              />
            </Col>
            <Col>
              <InputNumber
                label={t('Day')}
                max={31}
                min={0}
                name={'Day'}
                required
                value={item.Day}
              />
            </Col>
            <Col>
              <InputNumber
                label={t('Hour')}
                max={23}
                min={0}
                name={'Hour'}
                required
                value={item.Hour}
              />
            </Col>
            <Col>
              <InputNumber
                label={t('Minute')}
                max={59}
                min={0}
                name={'Minute'}
                required
                value={item.Minute}
              />
            </Col>
            <Col>
              <InputNumber
                label={t('Second')}
                max={59}
                min={0}
                name={'Second'}
                required
                value={item.Second}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <InputCheckbox
            label={t('Approved')}
            name={'Approved'}
            value={item.Approved}
          />
        </Col>
        <Col>
          <InputCheckbox
            label={t('Undiscard')}
            name={'Undiscard'}
            value={item.Undiscard}
          />
        </Col>
        <Col>
          <InputCheckbox
            label={t('Dominant')}
            name={'Dominant'}
            value={item.Dominant}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Course')}
            name={'Course'}
            value={item.Course}
          />
        </Col>
        <Col>
          <AvField
            label={t('Tws')}
            name={'Tws'}
            value={item.Tws}
          />
        </Col>
        <Col>
          <AvField
            label={t('Twa')}
            name={'Twa'}
            value={item.Twa}
          />
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <InputCheckbox
            label={t('Show time column')}
            name={'ShowTimeColumn'}
            value={item.ShowTimeColumn}
          />
        </Col>
        <Col>
          <InputCheckbox
            label={t('Show points column')}
            name={'ShowPointsColumn'}
            value={item.ShowPointsColumn}
          />
        </Col>
        <Col>
          <InputCheckbox
            label={t('Show place column')}
            name={'ShowPlaceColumn'}
            value={item.ShowPlaceColumn}
          />
        </Col>
      </Row>
    </>
  );
};

export default RegattaResultTableRaceFieldsView;
